export function centerMap(map, [lngX, latX, lngY, latY]) {
  map.fitBounds([[lngX, latX], [lngY, latY]]);
}
